import * as yup from 'yup';
import _isNaN from 'lodash/isNaN';
import { Row, RenderConfig, NumberInput, TextInput, AsyncSelect, Select } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	TICKET_ID: 'ticketId',
	CAMPAIGN_NAME: 'campaignName',
	AGENT_ID: 'agentId',
	PHONE_TYPE: 'phoneType'
};

export const validationSchema = yup.object().shape({
	ticketId: yup.number().test({
		message: 'Invalid ticketId',
		test: (value: any) => !_isNaN(value)
	}),
	campaignName: yup.string().required('Campaign Name is required'),
	phoneType: yup.string().oneOf(['PRIMARY', 'ALTERNATE']).required('Phone selection is required')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.TICKET_ID]: new RenderConfig()
		.setName('ticketId')
		.setLabel('ticketId')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.CAMPAIGN_NAME]: new RenderConfig()
		.setName('campaignName')
		.setLabel('Campaign Name')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.AGENT_ID]: new RenderConfig()
		.setName('agentId')
		.setLabel('Agent ID')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.PHONE_TYPE]: new RenderConfig()
		.setName('phoneType')
		.setLabel('Phone Type')
		.setRenderer(Select)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: [
				{ id: 'PRIMARY', label: 'Primary' },
				{ id: 'ALTERNATE', label: 'Alternate' }
			]
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.TICKET_ID),
	new Row(FORM_FIELD_KEYS.CAMPAIGN_NAME),
	new Row(FORM_FIELD_KEYS.AGENT_ID),
	new Row(FORM_FIELD_KEYS.PHONE_TYPE)
];
